
export const DetailProspectionResultat = ({openDownloadModal}) => {
    return (
        <>
            <div className="bg-white p-4 text-center text-muted">
                Cliquer sur <a onClick={openDownloadModal} role="button" className="cursor-pointer text-warning text-decoration-underline">ce lien</a> pour télécharger les résultats des analyses réalisées à ce jour suite à la campagne de prospection.
            </div>
        </>
    )
}